export default {
  estaCarregando: false,
  lista: []
}
